import { useState, type FormEvent } from 'react';
import { Toast } from 'antd-mobile';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { changePassword, useAuthUser } from '@ubus/shared';
import PageHeader from '../components/PageHeader';

function ChangePassword() {
  const { t } = useTranslation();
  const user = useAuthUser();
  const navigate = useNavigate();
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const email = user?.email;

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email) {
      Toast.show({ icon: 'fail', content: t('auth.notSignedIn') });
      return;
    }
    if (password.length < 8) {
      Toast.show({ icon: 'fail', content: t('auth.passwordMinLength') });
      return;
    }
    if (password !== confirm) {
      Toast.show({ icon: 'fail', content: t('auth.passwordMismatch') });
      return;
    }
    setLoading(true);
    try {
      const { error } = await changePassword(email, current, password);
      if (error) {
        Toast.show({ icon: 'fail', content: error.message });
        return;
      }
      Toast.show({ icon: 'success', content: t('auth.passwordUpdated') });
      navigate('/profile', { replace: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="driver-profile-page">
      <PageHeader title={t('auth.changePasswordTitle')} subtitle={t('auth.changePasswordSubtitle')} />
      <form className="driver-card" style={{ padding: 16 }} onSubmit={(e) => void handleSubmit(e)}>
        <label className="driver-login-label" htmlFor="cur">
          {t('auth.currentPassword')}
        </label>
        <input
          id="cur"
          className="driver-login-field"
          type="password"
          autoComplete="current-password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
          required
        />
        <label className="driver-login-label" htmlFor="npw" style={{ marginTop: 12 }}>
          {t('auth.newPassword')}
        </label>
        <input
          id="npw"
          className="driver-login-field"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <label className="driver-login-label" htmlFor="cpw" style={{ marginTop: 12 }}>
          {t('auth.confirmPassword')}
        </label>
        <input
          id="cpw"
          className="driver-login-field"
          type="password"
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
        <button
          type="submit"
          className="driver-login-submit driver-login-submit--active"
          style={{ marginTop: 20 }}
          disabled={loading}
        >
          {loading ? t('auth.saving') : t('auth.updatePassword')}
        </button>
      </form>
    </div>
  );
}

export default ChangePassword;
